<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-row>
      <v-col cols="12">
        <h5 class="mt-3 mb-0">Dashboard</h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="border-card p-16">
          <h5 class="mb-2 text-dark font-weight-bold">&#8377; 2000</h5>
          <h5 class="mb-2 ftext-dark font-weight-normal">
            Total income generated
          </h5>
          <p class="mb-0 p-clr">
            Total income generated by pay per use , this will include paid and
            to be recevable amount , includes existing months amounts to.
          </p>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="border-card p-16 h-100">
          <h5 class="mb-2 text-dark font-weight-bold">2000</h5>
          <h5 class="mb-2 text-dark font-weight-normal">Orders accepted</h5>
          <p class="mb-0 p-clr">
            This includes the total number of orders accepted with pay per use.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="border-card p-16 h-100">
          <h5 class="mb-2 text-dark font-weight-bold">&#8377; 2000</h5>
          <h5 class="mb-2 text-dark font-weight-normal">
            Total amount received
          </h5>
          <p class="mb-0 p-clr">
            This includes the total amount paid by users for pay per use.
          </p>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="border-card p-16 h-100">
          <h5 class="mb-2 text-dark font-weight-bold">&#8377; 2000</h5>
          <h5 class="mb-2 text-dark font-weight-normal">
            Total amount receivable
          </h5>
          <div class="d-flex justify-content-space-bet">
            <p class="mb-0 p-clr">
              Unbilled amount <span class="text-dark">&#8377; 2000</span>
            </p>
            <p class="mb-0 p-clr">
              Billed amount <span class="text-dark">&#8377; 2000</span>
            </p>
          </div>
          <p class="mb-0 p-clr">
            This includes the total number of orders accepted with pay per use.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="card-sm-4">
        <router-link :to="{ name: 'Owner List' }">
          <div class="py-4 px-7 border-card d-align">
            <image-view
              :src="'/img/avatars/settings.png'"
              alt="user image"
            ></image-view>
            <h5 class="mb-0 ml-4 font-weight-normal text-dark">Owner List</h5>
          </div>
        </router-link>
      </v-col>
      <v-col cols="4" class="card-sm-4">
        <router-link :to="{ name: 'Centre List' }">
          <div class="py-4 px-7 border-card d-align">
            <image-view
              :src="'/img/avatars/clinic.png'"
              alt="user image"
            ></image-view>
            <h5 class="mb-0 ml-4 font-weight-normal text-dark">Centre List</h5>
          </div>
        </router-link>
      </v-col>
      <v-col cols="4" class="card-sm-4">
        <router-link :to="{ name: 'Settings' }">
          <div class="py-4 px-7 border-card d-align">
            <image-view
              :src="'/img/avatars/settings.png'"
              alt="user image"
            ></image-view>
            <h5 class="mb-0 ml-4 font-weight-normal text-dark">Settings</h5>
          </div>
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>
<script>
const Image = () => import("@/components/image.vue");
export default {
  components: {
    "image-view": Image,
  },
};
</script>
<style  lang="scss">
.card-sm-4 {
  a {
    &:hover {
      text-decoration: none;
    }
  }
  .image-responsive {
    width: 50px;
  }
}
</style>